import { useCallback } from "react";

import { postHTML } from "@/lib/aws-amplify/storage";
import { LangCode } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { RoomArticleUpdate_DesignPage_Mutation } from "./mutation";

type Props = {
	hotelID: string;
	roomID: string;
};

export const useRoomArticleUpdateMutation = ({ hotelID, roomID }: Props) => {
	const { mutationFunc } = useCustomMutation(RoomArticleUpdate_DesignPage_Mutation);

	const onUpdate = useCallback(
		async ({
			articleHTML,
			tags,
			tagsLocation,
		}: {
			articleHTML: string;
			tags: Array<string>;
			tagsLocation: Array<string>;
		}) => {
			const { s3Object } = await postHTML({
				html: articleHTML,
				lang: LangCode.Default,
				hotelID,
				resourceID: roomID,
			});

			return await mutationFunc({
				variables: {
					input: {
						hotelID,
						roomID,
						article: s3Object,
						articleTitle: "",
						tags,
						tagsLocation,
					},
				},
			});
		},
		[hotelID, mutationFunc, roomID],
	);

	return {
		onUpdate,
	};
};
